// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box1 {
  width: 16.666%;
  height: 7px;
  background: #61CFFB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.box2 {
  width: 16.666%;
  height: 7px;
  background: #52B6EB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.box3 {
  width: 16.666%;
  height: 7px;
  background: #3E9DD6 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.box4 {
  width: 16.666%;
  height: 7px;
  background: #3386C5 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.box5 {
  width: 16.666%;
  height: 7px;
  background: #286EB8 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.box6 {
  width: 16.666%;
  height: 7px;
  background: #1F56A9 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  margin-left: 0px;
}

.main {
  display: flex;
  flex-direction: row;
  margin-left: 0px !important;
  margin-right: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/ui-components/bluebox/bluebox.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BAAA;AACF","sourcesContent":[".box1 {\n  width: 16.666%;\n  height: 7px;\n  background: #61CFFB 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.box2 {\n  width: 16.666%;\n  height: 7px;\n  background: #52B6EB 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.box3 {\n  width: 16.666%;\n  height: 7px;\n  background: #3E9DD6 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.box4 {\n  width: 16.666%;\n  height: 7px;\n  background: #3386C5 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.box5 {\n  width: 16.666%;\n  height: 7px;\n  background: #286EB8 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.box6 {\n  width: 16.666%;\n  height: 7px;\n  background: #1F56A9 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n.main {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
